<template>
  <div>
    <div class="q-mt-md">
      <div class="row-reverse">
        <q-btn
          color="primary"
          label="Add Customer Bag Pit"
          @click="onAdd"
          class="q-mb-md q-ml-lg"
        />
      </div>
    </div>
    <BaseTable
      :rows="formattedCustomerBagPits"
      :columns="columns"
      :total-rows="totalCustomerBagPits"
      :get-edit-url="getEditUrl"
    />
  </div>
</template>

<script>
import BaseTable from '@/components/BaseTable';
import axios from 'axios';

export default {
  name: 'CustomerBagPitTable',
  components: {
    BaseTable
  },
  data() {
    return {
      customerBagPits: [],
      totalCustomerBagPits: 0,
      columns: [
        { name: 'customer_name', align: 'left', label: 'Customer', field: 'customer_name', sortable: true },
        { name: 'name', align: 'left', label: 'Name', field: 'name', sortable: true },
        { name: 'bag_pit_type', align: 'left', label: 'Bag Pit Type', field: 'bag_pit_type', sortable: true },
        { name: 'add_date', align: 'left', label: 'Add Date', field: 'add_date', sortable: true },
        { name: 'edit_date', align: 'left', label: 'Edit Date', field: 'edit_date', sortable: true },
        { name: 'actions', align: 'center', label: 'Actions', field: 'actions', sortable: false }
      ]
    };
  },
  computed: {
    formattedCustomerBagPits() {
      return this.customerBagPits.map(bagPit => ({
        ...bagPit,
        customer_name: bagPit.customer_id ? bagPit.customer_id.name : 'None', // Assuming the API returns nested customer object with `name`
        bag_pit_type: bagPit.bag_pit_type_id ? bagPit.bag_pit_type_id.name : 'None', // Handling nullable bag_pit_type
        add_date: new Date(bagPit.add_date).toLocaleDateString(),
        edit_date: new Date(bagPit.edit_date).toLocaleDateString()
      }));
    }
  },
  created() {
    this.fetchCustomerBagPits();
  },
  methods: {
    fetchCustomerBagPits() {
      axios
        .get('/api/v1/customer_bag_pit/customer_bag_pits/')
        .then(response => {
          this.customerBagPits = response.data;
          this.totalCustomerBagPits = response.data.length;
        })
        .catch(error => {
          console.error('Error fetching customer bag pits:', error);
        });
    },
    onAdd() {
      this.$router.push('/customer_bag_pit/add');
    },
    getEditUrl(row) {
      return `/customer_bag_pit/edit/${row.id}`;
    }
  },
  watch: {
    customerBagPits() {
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
/* Add any specific styles for the CustomerBagPitTable here */
</style>
